import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Mail } from 'lucide-react';

export const ContactDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-heading">Contact Us</DialogTitle>
        </DialogHeader>
        
        <div className="flex items-center gap-3 py-4">
          <Mail className="w-5 h-5 text-muted-foreground" />
          <a 
            href="mailto:contact@cashforth.com" 
            className="text-primary hover:underline"
          >
            contact@cashforth.com
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
